<template>
  <div class="header-bar">
    <!-- <div class="header-title">{{title}}</div> -->
    <!-- <custom-bread-crumb show-icon style="margin-left: 30px;" :list="breadCrumbList"></custom-bread-crumb> -->
    <div style="float: left; width: 400px">
      <Row type="flex"  align="middle" class="code-row-bg">
        <Col flex="1">
          <div style="line-height: 1">
            <img :src="maxLogo" class="logo" alt="" />
          </div>
        </Col>
        <Col flex="2"><span class="logo-text">就业云 - 企业平台</span></Col>
      </Row>
    </div>
    <div class="custom-content-con">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import maxLogo from '@/assets/images/logo.png';

import './header-bar.less';
export default {
  name: 'HeaderBar',
  components: {
    maxLogo: maxLogo
  },
  data() {
    return {
      title: null,
      maxLogo: maxLogo
    };
  },
  props: {
    collapsed: Boolean
  },
  watch: {
    $route() {
      this.title = this.$router.app._route.meta.title;
    }
  },
  mounted() {
    this.title = this.$router.app._route.meta.title;
  },

  methods: {}
};
</script>
